import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, DEFAULT_OG_IMAGE, GEO } from "./siteConfig";

/**
 * Per-page SEO + GEO head manager.
 * Renders title, description, canonical, robots, geo, Open Graph,
 * Twitter cards and any JSON-LD schema objects passed in `schema`.
 */
const Seo = ({
  title,
  description,
  path = "/",
  image,
  type = "website",
  schema = [],
  noindex = false,
}) => {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en-US" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        }
      />

      {/* Local / GEO */}
      <meta name="geo.region" content={GEO.region} />
      <meta name="geo.placename" content={GEO.placename} />
      <meta name="geo.position" content={`${GEO.lat};${GEO.lng}`} />
      <meta name="ICBM" content={`${GEO.lat}, ${GEO.lng}`} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Talk N' Fix" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="675" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {/* JSON-LD structured data */}
      {schema.map((s, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
